import { useMemo } from 'react';

import { IconCalendar } from '@u21/tabler-icons';
import {
  U21Select,
  U21SelectOptionProps,
  U21SelectProps,
} from 'app/shared/u21-ui/components';

import { useSelector } from 'react-redux';
import { selectHasReadSchedulePermission } from 'app/modules/session/selectors';
import { useGetAllSchedules } from 'app/modules/schedule/queries/useGetAllSchedules';

export interface U21ScheduleSelectProps<
  TClearable extends boolean,
> extends Omit<U21SelectProps<number, TClearable>, 'options'> {}

export const U21ScheduleSelect = <TClearable extends boolean = true>(
  props: U21ScheduleSelectProps<TClearable>,
) => {
  const { onChange, value, ...rest } = props;

  const { data } = useGetAllSchedules();

  const hasReadSchedulePermission = useSelector(
    selectHasReadSchedulePermission,
  );

  const options = useMemo<U21SelectOptionProps[]>(
    () =>
      data.schedules.map((schedule) => ({
        value: schedule.id,
        text: schedule.name,
        icon: <IconCalendar />,
      })),
    [data.schedules],
  );

  if (!hasReadSchedulePermission) {
    return null;
  }

  return (
    <U21Select
      allowInvalidValues
      options={options}
      startIcon={<IconCalendar />}
      onChange={onChange}
      value={value}
      {...rest}
    />
  );
};
